import { UserPagesApi } from "@/apis/UserPagesApi";
import { CustomBackdropController } from "@/components/backdrop/default/v1";
import { customToast } from "@/components/toast/custom-react-toastify/v1";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const QUERY_KEY = 'UserPage';

export function useUserPageQuery({
    isLoggedIn,
    isReady,
    accessToken
}) {
    const queryResult = useQuery({
        queryKey: [QUERY_KEY, accessToken],
        enabled: !!(isLoggedIn && isReady),
        queryFn: async () => {
            const fetchResult = await UserPagesApi().searchByAuthUser({});

            return fetchResult;
        },
        staleTime: 5000
    });

    return queryResult;
}

export function useCreateUserPageMutation() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ params, headers, body }) => {

            const response = await UserPagesApi().create({
                headers: headers,
                body: body
            })

            return response;
        },
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
        },
        onError: (error, variables, context) => {
            if (!error) {
                customToast.error('서버와의 연결이 원활하지 않습니다.');
                return;
            }

            let res = error.response;

            customToast.error(res?.data?.message);
        },
        onMutate: async () => {
            CustomBackdropController().showBackdrop();
        },
        onSettled: async () => {
            CustomBackdropController().hideBackdrop();
        }
    });
}

export function useUpdateUserPageMutation() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ params, headers, body }) => {

            const response = await UserPagesApi().update({
                headers: headers,
                body: body
            })

            return response;
        },
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
        },
        onError: (error, variables, context) => {
            if (!error) {
                customToast.error('서버와의 연결이 원활하지 않습니다.');
                return;
            }

            let res = error.response;

            customToast.error(res?.data?.message);
        },
        onMutate: async () => {
            CustomBackdropController().showBackdrop();
        },
        onSettled: async () => {
            CustomBackdropController().hideBackdrop();
        }
    });
}

export function useChangeUserPageNoticeConfigMutation() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ params, headers, body }) => {

            const response = await UserPagesApi().changeOne_noticeConfig({
                headers: headers,
                body: body
            })

            return response;
        },
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
        },
        onError: (error, variables, context) => {
            if (!error) {
                customToast.error('서버와의 연결이 원활하지 않습니다.');
                return;
            }

            let res = error.response;

            customToast.error(res?.data?.message);
        },
        onMutate: async () => {
            CustomBackdropController().showBackdrop();
        },
        onSettled: async () => {
            CustomBackdropController().hideBackdrop();
        }
    });
}

export function useChangeUserPageSearchConfigMutation() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ params, headers, body }) => {

            const response = await UserPagesApi().changeOne_searchConfig({
                headers: headers,
                body: body
            })

            return response;
        },
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
        },
        onError: (error, variables, context) => {
            if (!error) {
                customToast.error('서버와의 연결이 원활하지 않습니다.');
                return;
            }

            let res = error.response;

            customToast.error(res?.data?.message);
        },
        onMutate: async () => {
            CustomBackdropController().showBackdrop();
        },
        onSettled: async () => {
            CustomBackdropController().hideBackdrop();
        }
    });
}

export function useChangeUserPageSocialConfigMutation() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ params, headers, body }) => {

            const response = await UserPagesApi().changeOne_socialConfig({
                headers: headers,
                body: body
            })

            return response;
        },
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
        },
        onError: (error, variables, context) => {
            if (!error) {
                customToast.error('서버와의 연결이 원활하지 않습니다.');
                return;
            }

            let res = error.response;

            customToast.error(res?.data?.message);
        },
        onMutate: async () => {
            CustomBackdropController().showBackdrop();
        },
        onSettled: async () => {
            CustomBackdropController().hideBackdrop();
        }
    });
}

export function useChangeUserPageViewCategoryFlagMutation() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ params, headers, body }) => {

            const response = await UserPagesApi().changeOne_viewCategoryFlag({
                headers: headers,
                body: body
            })

            return response;
        },
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
        },
        onError: (error, variables, context) => {
            if (!error) {
                customToast.error('서버와의 연결이 원활하지 않습니다.');
                return;
            }

            let res = error.response;

            customToast.error(res?.data?.message);
        },
        onMutate: async () => {
            CustomBackdropController().showBackdrop();
        },
        onSettled: async () => {
            CustomBackdropController().hideBackdrop();
        }
    });
}

export function useChangeUserPageDesignsMutation() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ params, headers, body }) => {

            const response = await UserPagesApi().changeOne_designs({
                headers: headers,
                body: body
            })

            return response;
        },
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
        },
        onError: (error, variables, context) => {
            if (!error) {
                customToast.error('서버와의 연결이 원활하지 않습니다.');
                return;
            }

            let res = error.response;

            customToast.error(res?.data?.message);
        },
        onMutate: async () => {
            CustomBackdropController().showBackdrop();
        },
        onSettled: async () => {
            CustomBackdropController().hideBackdrop();
        }
    });
}

export function useChangeUserPageBackgroundDesignMutation() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ params, headers, body }) => {

            const response = await UserPagesApi().changeOne_backgroundDesign({
                headers: headers,
                body: body
            })

            return response;
        },
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
        },
        onError: (error, variables, context) => {
            if (!error) {
                customToast.error('서버와의 연결이 원활하지 않습니다.');
                return;
            }

            let res = error.response;

            customToast.error(res?.data?.message);
        },
        onMutate: async () => {
            CustomBackdropController().showBackdrop();
        },
        onSettled: async () => {
            CustomBackdropController().hideBackdrop();
        }
    });
}

export function useChangeUserPagePageFontMutation() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ params, headers, body }) => {

            const response = await UserPagesApi().changeOne_pageFont({
                headers: headers,
                body: body
            })

            return response;
        },
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
        },
        onError: (error, variables, context) => {
            if (!error) {
                customToast.error('서버와의 연결이 원활하지 않습니다.');
                return;
            }

            let res = error.response;

            customToast.error(res?.data?.message);
        },
        onMutate: async () => {
            CustomBackdropController().showBackdrop();
        },
        onSettled: async () => {
            CustomBackdropController().hideBackdrop();
        }
    });
}